import flatpickr from 'flatpickr'
import { Dutch } from 'flatpickr/dist/l10n/nl'

flatpickr.localize(Dutch)

export { flatpickr }
